module.exports = __webpack_public_path__ + "static/media/macaron_label.9f38ac50.png";